package ru.villawonka.app.data.source

import io.ktor.client.HttpClient
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import ru.villawonka.app.data.entity.request.SearchAccommodationRequest
import ru.villawonka.app.data.entity.response.AccommodationPostResponse
import ru.villawonka.app.data.entity.response.PaginatedResponse
import ru.villawonka.app.data.utils.parseResponse
import ru.villawonka.app.AppConfig

class PostsApi(
    private val client: HttpClient,
) {

    suspend fun searchAccommodation(
        searchRequest: SearchAccommodationRequest
    ): PaginatedResponse<AccommodationPostResponse> = parseResponse {
        client.post("${AppConfig.apiUrl}/posts/accommodation/search") {
            setBody(searchRequest)
        }
    }

    suspend fun requestFavoriteAccommodationPosts(): List<AccommodationPostResponse> = parseResponse {
        client.get("${AppConfig.apiUrl}/posts/accommodation/favorites")
    }

    suspend fun requestAccommodationPostById(postId: Int): AccommodationPostResponse = parseResponse {
        client.get("${AppConfig.apiUrl}/posts/accommodation/${postId}")
    }

    suspend fun likeAccommodationPost(postId: Int): Unit = parseResponse {
        client.put("${AppConfig.apiUrl}/posts/accommodation/${postId}/like")
    }

    suspend fun dislikeAccommodationPost(postId: Int): Unit = parseResponse {
        client.put("${AppConfig.apiUrl}/posts/accommodation/${postId}/dislike")
    }
}